import { configureStore } from "@reduxjs/toolkit";
import blogsReducer from "../features/Blogs/BlogsSlice";
import blogReducer from "../features/DetailsBlog/DetailsBlogSlice";
import filterReducer from "../features/Filter/filterSlice";
import relatedBlogsReducer from "../features/RelatedBlogs/RelatedBlogsSlice";

export const store = configureStore({
  reducer: {
    blogs: blogsReducer,
    blog: blogReducer,
    relatedBlogs: relatedBlogsReducer,
    filter: filterReducer,
  },
});
